'use client';
import React, { useState } from 'react';

import LinkWrapper from '../link-wrapper/link-wrapper';
import MinusIcon from '@/assets/icons/minus.svg';
import PlusIcon from '@/assets/icons/plus.svg';
import { isBrowser } from '@/helpers/is-browser';
import { ILibraryMenuGroup } from '@/lib/fragments/libraryMenuGroup';
import { useUser } from '@/providers/UserProvider';
import { useIsMPLivliFamily } from '@/providers/ConfigProvider';

interface SubMenuProps {
  menuGroup: ILibraryMenuGroup;
  id: string;
  isMobile: boolean;
  onLinkClick?: () => void;
}

export const FoldOutMenuSubMenu = ({
  menuGroup,
  id,
  isMobile,
  onLinkClick,
}: SubMenuProps) => {
  const [open, setOpen] = useState<boolean>(false);

  const { user } = useUser();
  const isLivliFamily = useIsMPLivliFamily();

  const sendGtmEvent = (linkText: string) => {
    if (isBrowser && dataLayer) {
      dataLayer.push({
        event: 'menu_click',
        menu_item: linkText,
        menu_section: menuGroup.title,
        user_status: isLivliFamily ? (user ? 'logged_in' : 'guest') : undefined,
      });
    }
  };

  return (
    <div>
      <button
        className="w-full pb-4 pt-3 text-left font-title text-headingm max-lg:flex max-lg:items-center max-lg:justify-between lg:pointer-events-none lg:pb-2.5"
        onClick={() => setOpen(!open)}
        aria-controls={`submenugroup-${id}`}
        aria-expanded={open}
      >
        <span>{menuGroup.title}</span>
        <span className="lg:hidden">
          {open && <MinusIcon />}
          {!open && <PlusIcon />}
        </span>
      </button>
      <ul
        className={`${open ? 'block' : 'hidden'} lg:block`}
        id={`submenugroup-${id}`}
        aria-hidden={isMobile && !open}
      >
        {menuGroup?.pagesCollection?.items
          ?.filter(Boolean)
          ?.map((page: any, index: any) => {
            const linkText =
              page.__typename === 'LibraryExternalLink'
                ? page.linkTitle
                : page.name;
            return (
              (page.linkTitle || page.name) && (
                <li className="mb-4" key={`${page.slug}-${index}`}>
                  <LinkWrapper
                    onClick={() => {
                      sendGtmEvent(linkText ?? '');
                      onLinkClick?.();
                    }}
                    data={page}
                    className="mb-3 block lg:hover:text-text-light lg:hover:underline"
                  >
                    {linkText}
                  </LinkWrapper>
                </li>
              )
            );
          })}
      </ul>
    </div>
  );
};
